<div class="full-width footer">
  <div class="container">
    <div class="sections full-width">
      <div
        class="section"
        [class.w-3]="!deviceService.isTablet()"
        [class.w-5]="deviceService.isTablet()"
        [class.w-12]="deviceService.isMobile()"
      >
        <div class="title">Le blog</div>
        <div class="links">
          @if(!deviceService.isMobile()) {
          <a href="/">Home</a>
          <a href="/carte">Map</a>
          <a href="/Belgique">Belgique</a>
          <a href="/materiel">Notre Matériel</a>
          }
          <a href="/contact">Contact</a>
          <a href="/legal-notice">Mentions légales</a>
        </div>
      </div>
      @if(!deviceService.isMobile()){
      <div
        class="section ml-1"
        [class.w-3]="!deviceService.isTablet()"
        [class.w-5]="deviceService.isTablet()"
      >
        <div class="title">Nos destinations</div>
        <div class="links">
          @for (destination of destinations; track $index) {
          <a [href]="'/destination/' + destination.country">{{ destination.country }}</a>
          }
        </div>
      </div>
      }
      <div
        class="section"
        [class.w-3]="deviceService.isDesktop()"
        [class.w-5]="deviceService.isTablet()"
        [class.w-8]="deviceService.isMobile()"
      >
        <div class="title">Suivez nos explorations</div>
        <div class="media">
          <a href="https://instagram.com/lesexplorateurs.dumonde" target="_blank">
            <img ngSrc="/icons/instagram.svg" width="16" height="16" alt="instagram" />
          </a>
          <a href="https://facebook.com/lesexplorateursdumonde" target="_blank">
            <img ngSrc="/icons/facebook.svg" width="16" height="16" alt="facebook" />
          </a>
          <a href="https://tiktok.com/@lesexplorateursdumonde" target="_blank">
            <img ngSrc="/icons/tiktok.svg" width="16" height="16" alt="tiktok" />
          </a>
          <a href="https://youtube.com/channel/UCwWohrVcLOeUztcfJ7bf3Ww" target="_blank">
            <img ngSrc="/icons/youtube.svg" width="16" height="16" alt="youtube" />
          </a>
        </div>
      </div>
    </div>
    <div class="credits w-12">
      <div class="credit">&#64;lesexplorateursdumonde, {{ currentYear }}</div>
      <img loading="lazy" alt="logo" ngSrc="/footer/logo.svg" width="60" height="60" />
    </div>
  </div>
</div>
